import { c as _c } from "react/compiler-runtime";
import type { BuyerPaymentMethod } from "@/api";

/**
 * Карта покупателя (fd-payment-01, 31.10.2026).
 *
 * Раньше здесь была форма с номером карты, сроком и CVC, а «токен» карты
 * генерировался в браузере (`card_<uuid>`) — к платёжной системе такая
 * запись отношения не имела, и при оплате карту вводили заново. Принимать
 * реквизиты карты на своём домене площадка не вправе (нужна сертификация
 * PCI DSS), поэтому формы больше нет: карта сохраняется при оплате заказа с
 * отметкой «Сохранить карту», а шлюз хранит только токен провайдера и маску.
 */

/** Подсказка «как добавить карту» — в профиле и в оформлении. */
export function SavedCardHint() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-2 text-[14px] leading-[18px] text-[#1F1F1F]/72" data-testid="saved-card-hint"><p>Карта сохраняется при оплате заказа: на шаге оплаты отметьте «Сохранить карту».</p><p>Номер карты и CVC вводятся только на странице платёжной системы. Мы храним лишь её маску и токен платёжной системы - по нему следующий заказ оплачивается без ввода номера.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}

/** Подпись сохранённой карты: «МИР •• 3456», срок, если провайдер его отдал. */
export const savedCardLabel = (m: Pick<BuyerPaymentMethod, "brand" | "last4" | "label" | "expiresAt">): string => {
  const raw = m.brand || "Карта";
  const brand = ["MIR", "МИР"].includes(raw.toUpperCase()) ? "МИР" : raw;
  if (!m.last4) return m.label || brand;
  return `${brand} •• ${m.last4}`;
};

/** «до 12/30» — срок действия, если он известен. */
export const savedCardExpiry = (m: Pick<BuyerPaymentMethod, "expiresAt">): string => /^\d{2}\/\d{2}$/.test(m.expiresAt) ? `до ${m.expiresAt}` : "";